const PaymentStatusBadge = ({
  status,
  settledVia,
  paidAmount,
  finalAmount,
  className = "",
}) => {
  const getPaymentStatusTheme = (status = "") => {
    const normalized = status?.toLowerCase?.() || "";

    const statusMap = {
      unpaid: {
        label: "Unpaid",
        badge: "bg-gray-100 text-gray-600 border-gray-200",
      },

      pending_verification: {
        label: "Verifying",
        badge: "bg-amber-50 text-amber-700 border-amber-300",
      },

      payment_pending: {
        label: "Pending",
        badge: "bg-blue-50 text-blue-700 border-blue-300",
      },

      partially_paid: {
        label: "Partial",
        badge: "bg-indigo-50 text-indigo-700 border-indigo-300",
      },

      paid: {
        label: "Paid",
        badge: "bg-emerald-50 text-emerald-700 border-emerald-300",
      },

      refunded: {
        label: "Refunded",
        badge: "bg-red-50 text-red-600 border-red-200",
      },
    };

    return (
      statusMap[normalized] || {
        label: "Unknown",
        badge: "bg-gray-100 text-gray-500 border-gray-200",
      }
    );
  };

  const { label, badge } = getPaymentStatusTheme(status);

  const settlementSuffix =
    status === "paid" && settledVia
      ? settledVia === "UPI_QR"
        ? " • UPI"
        : settledVia === "CASH"
          ? " • Cash"
          : ""
      : "";

  const isPartial = status === "partially_paid";

  return (
    <span
      className={`inline-flex flex-col items-center justify-center min-w-[110px] px-2.5 py-1 rounded-full text-xs font-medium border ${badge} ${className}`}
    >
      <span>
        {label}
        {settlementSuffix}
      </span>

      {/* Show amount only if partial and values exist */}
      {isPartial && paidAmount !== undefined && finalAmount !== undefined && (
        <span className="text-[10px] opacity-80">
          ₹{paidAmount} / ₹{finalAmount}
        </span>
      )}
    </span>
  );
};

export default PaymentStatusBadge;